/**
 * 彩种相关
 */
import * as ACTION from '../constants/types/lotteryTypes';
import * as $$USER from './userAction'
import * as $$BASE from './baseAction'
import $CACHE from '../helpers/cache.js'
import { packageReq } from '../helpers/request';
import { CANNOT_TRACK_LOTTERY, ACTIVE_MISSING_FN_LOTTERY } from '../constants/lotterys/config'

// 获取彩种销售信息
export function getLotterySaleInfo(){
 
	var payload = packageReq('LOTTERY_SALEINFO', null, null, 'GET');

	return {
		type: ACTION.GET_LOTTERY_SALEINFO,
		payload
	}

}


/**
 * [nextCurrentIssue description]
 * @author ammo 2018-08-03
 * @param  {[type]} windowId               [description]
 * @param  {[type]} lotteryId              [description]
 * @param  {[type]} lotteryAlias           [description]
 * @param  {[type]} requestNewTrackingInfo [是否请求新的追号信息]
 * @param  {[type]} track_limit            [当前可追期数]
 * @return {[type]}                        [description]
 */
export function nextCurrentIssue(windowId, lotteryId, lotteryAlias, requestNewTrackingInfo, track_limit){
	return {
						type: ACTION.NEXT_CURRENT_ISSUE,
						lotteryId: lotteryId,
						windowId: windowId,
						relations: requestNewTrackingInfo ? 
						[
							getTrackIssues(lotteryId, windowId, track_limit)
						]
						: null
					}
}


// 初始化彩种信息
export function initLotteryMethods(methods){

	return {type: ACTION.INIT_METHODS, methods: methods}

}


// 获取彩种动态信息
export function getDynamicMethodInfo(result, action){

	var payload = packageReq('DYNAMIC_METHOD_INFO', null, null, 'GET');

	return {
		type: ACTION.GET_DYNAMIC_METHOD_INFO,
		payload,
		ignoreError: true,
		extend: result.data.userid,
		_error_:[
			{
				action: setNoBetAuthError,
				takeParam: true
			}
		]
	}
}

// 从缓存获取彩种动态信息
export function getDynamicMethodInfoFromCache(result, action){
	return {
		type: ACTION.GET_DYNAMIC_METHOD_INFO_FROM_CACHE,
		userid: result.data.userid
	}
}

// 没有开通彩种投注权限
export function setNoBetAuthError(result){
	return {
		type: ACTION.SET_NO_BET_AUTH_ERROR,
		message: result.message,
		status: result.status
	}
}

// 设置当前玩法区
export function setWindowMethods(lotteryFlag, windowId){

	var current = {};

	current.flag = lotteryFlag;
	current.id = window.METHODS.static[lotteryFlag].lotteryId
	current.curmid = window.METHODS.static[lotteryFlag].curmid
	// 冷热遗漏
	let activeMissFn = [];
	if (_.includes(ACTIVE_MISSING_FN_LOTTERY, lotteryFlag)) {
		activeMissFn = [
			getValidNumber(windowId, current.id)
		]
	}
	return {
		type: ACTION.SET_WINDOW_METHOD,
		data: current,
		windowId: windowId,
		relations: [
			getCurrentLotteryIssue(current.flag, windowId),
			getHistoryIssues(current.id, windowId, 25),
			getLotteryStaticInfos(current.flag),
			...activeMissFn
		]
	}

}


// 设置当前窗口ID （预留，做投注页多窗口使用）
export function setWindowId(windowId){
	return {
		type: ACTION.SET_WINDOWID,
		data: windowId
	}
}

// 清空当前彩种窗口内容
export function clearWindowData(windowId){
	return {
		type: ACTION.CLEAR_WINDOW_METHOD,
		windowId: windowId
	}
}

// 打开关闭动画
export function toggleDisplayAnimation(windowId, status){
	return {
		type: ACTION.TOGGLE_DISPLAY_ANIMATION,
		windowId: windowId,
		status: status
	}
}

// 添加投注到订单
// methodId 用于判断订单内是否有重复的投注单
export function addOrder(submit, display, windowId, methodId){
	
	const uniqueId = new Date().getTime();
	
	return {
		type: ACTION.ADD_BET_TO_ORDER,
		data: {
			submit: _.merge({id: uniqueId}, submit),
			display: _.merge({id: uniqueId, methodId: methodId}, display),
			windowId: windowId
		},
		relations: [
			resetTrackInfo(windowId)
		]
	}
}

// 删除投注单
export function removeOrder(windowId, betId){
	return {
		type: ACTION.REMOVE_BET_FROM_ORDER,
		data: {
			windowId: windowId,
			betId: betId
		},
		relations: [
			resetTrackInfo(windowId)
		]
	}
}

// 删除单挑注单
export function removeSoloOrder(windowId){
	return {
		type: ACTION.REMOVE_SOLOBET_FROM_ORDER,
		data: {
			windowId: windowId
		},
		relations: [
			resetTrackInfo(windowId)
		]
	}
}

// 添加六合彩到订单
export function addLhcOrder(submit, display, windowId){
	
	let submitArr = [], displayArr = [];
	const key = new Date().getTime();
	_.forEach(display, function(item, index){
		const uniqueId = key + index;
		let eachDisplay = _.merge({id: uniqueId}, display[index])
		let eachSubmit = _.merge({id: uniqueId}, submit[index])
		submitArr.push(eachSubmit);
		displayArr.push(eachDisplay);
	})
	
	return {
		type: ACTION.ADD_BET_TO_ORDER_FOR_LHC,
		data: {
			submit: submitArr,
			display: displayArr,
			windowId: windowId
		}
	}
}


// 获取当前彩种销售信息
export function getCurrentLotteryIssue(lotteryFlag, windowId){
	// 获取彩种对应ID
	const id = window.METHODS.static[lotteryFlag].lotteryId;
	var payload = packageReq('GET_CURRENT_ISSUE', [id], null, 'GET');
	return {
		type: ACTION.GET_CURRENT_ISSUE,
		extend: windowId,
		payload,
		lotteryId: id,
		_success_: [
			{
				action: function(payload, action){
					if (!payload.data || !payload.data.track_limit) {
						return {type: 'DO_NOT_REQUEST_TRACKING'}
					}
					return getTrackIssues(action.lotteryId, action.extend, payload.data.track_limit)
				},
				takeParam: true
			}
		],
		_error_:[
			{
				action: setLotteryErrors,
				takeParam: true
			}
		],
		ignoreError: true
	}
}

// 获取最近开奖
export function getLastLotteryCode(lotteryFlag, windowId){
	// 获取彩种对应ID
	const id = window.METHODS.static[lotteryFlag].lotteryId;
	var payload = packageReq('GET_LAST_ISSUE', [id], null, 'GET');
	return {
		type: ACTION.GET_LAST_ISSUE,
		extend: windowId,
		payload
	}
}

// 获取可追奖期
export function getTrackIssues(lotteryId, windowId, track_limit=200){
	var payload = packageReq('GET_TRACK_ISSUES', [lotteryId, track_limit + 20], null, 'GET');
	return {
		type: ACTION.GET_TRACK_ISSUES,
		extend: windowId,
		payload,
		ignoreError: true,
		lotteryId: lotteryId,
		_error_:[
			{
				action: setLotteryErrors,
				takeParam: true
			}
		],
		delayAction: 2
	}
}

// 设置彩种错误信息
export function setLotteryErrors(payload, action){
	return {
		type: ACTION.SET_LOTTERY_ERRORS,
		message: payload.message,
		windowId: action.extend,
		lotteryId: action.lotteryId
	}
}

// 设置追号信息
export function setTrackInfo(trace, windowId){
	return {
		type: ACTION.SET_TRACK_INFO,
		trace: trace,
		windowId: windowId,
	}
}

// 重置追号信息
export function resetTrackInfo(windowId){
	return{
		type: ACTION.RESET_TRACK_INFO,
		windowId: windowId
	}
}

// 投注
export function submitBet(bet, windowId){
	let extend = {
		lt_total_nums: _.sum(_.map(bet.submit, 'nums')),
		lt_total_money: _.round(_.sum(_.map(bet.submit, 'money')), 3).toFixed(3),
		lt_project: bet.submit,
		lt_issue_start: bet.current_issue.current.issue || '1',
		lt_trace_if: 'no'
	}
	// 可以追号的
	if (!_.includes(CANNOT_TRACK_LOTTERY, bet.flag)) {
		extend.lt_trace_if = _.size(bet.trace.lt_trace_issues) > 0 ? 'yes' : 'no'
	}
	const request = _.merge(extend, bet.request, bet.trace);
	const payload = packageReq('LOTTERY_BET', null, request, 'POST', {text: '投注提交中，请稍后...'});
	return {
		type: ACTION.LOTTERY_BET,
		payload,
		_success_: [
			{
				action: $$USER.getUserBetRecent(),
				takeParam: false
			},
			{
				action: $$USER.getLotteryBalance(),
				takeParam: false
			},
			{
				action: alertBetResult,
				takeParam: true
			}
		],
		windowId: windowId,
		flag: bet.flag
	}
}

// 投注成功失败提示
export function alertBetResult(result, action){
	const {message, data} = result;
	// 完全成功
	if (message == 'success') {
		return {
			type: 'BET_SUCCESS_RELATIONS',
			relations:[
				$$BASE.openToast('投注成功',null,3),
				removeOrder(action.windowId),
				resetTrackInfo(action.windowId)
			]
		}
	}	
	// 部分成功
	let text = '<h4 class="title">成功投注：'+ data.successed +'单，失败：' + data.failed + '单 - 以下内容投注失败:</h4><div class="floatarea">';
	_.each(data.errors, function(error){
		text += '<p>' + error + '</p>';
	})
	text += '</div><div class="totleNum"><p>是否需要清空所有投注项？</p></div>'
	return $$BASE.openConfirm(text, betSuccessRelation, null, '提示', {windowId: action.windowId}, null, 'modal-ssc-original modal-ssc-tips');
}

// 投注成功确认时联动
export function betSuccessRelation(windowId) {
	return {
		type: 'BET_SUCCESS_RELATIONS',
		relations: [
			removeOrder(windowId),
			resetTrackInfo(windowId)
		]
	}
}

/**
 * 秒秒彩投注
 * 秒秒彩投注大致redux扭转逻辑如下：
 * 1. 每两秒请求一次
 * 2. 发起请求时弹出BASE.OPEN_ALERT
 * 3. 将MMC正在投注的状态beting 设置为true
 * 4. BASE_ALERT的确定回调函数将正在投注状态设置为false
 * 5. 发起请求时将模拟投注的状态设置为true
 * 6. 请求结束时将模拟投注的状态设置为false
 * @param  {[type]} bet      [description]
 * @param  {[type]} windowId [description]
 * @param  {[type]} times    [description]
 * @return {[type]}          [description]
 */
export function mmcSubmitBet(bet, windowId, times){
	let extend = {
		lt_total_nums: _.sum(_.map(bet.submit, 'nums')),
		lt_total_money: _.round(_.sum(_.map(bet.submit, 'money')) * bet.times, 3).toFixed(3),
		lt_project: bet.submit,
		lt_issue_start: '1',
		lt_trace_if: 'no'
	}
	const request = _.merge(extend, bet.request, bet.trace);
	let payload = packageReq('LOTTERY_MMC_BET', null, request, 'POST');
	payload.data.times = times;
	return {
		type: ACTION.MMC_LOTTERY_BET,
		payload,
		extend: {
			windowId: windowId,
			times: times
		},
		_error_:[
			{
				action: toggleSimulatStatus(windowId, false),
				takeParam: false
			}
		],
		_success_: [
			{
				action: $$USER.getUserBetRecent(),
				takeParam: false
			},
			{ 
				action: $$USER.getLotteryBalance(),
				takeParam: false
			}
		],
		relations: [
			changeMmcBetStatus(windowId, true),
		]
	}
}

// 变更秒秒彩投注状态
export function changeMmcBetStatus(windowId, status = false){
	return {
		type: ACTION.CHANGE_MMC_BET_STATUS,
		status: status,
		windowId: windowId,
		relations: status ? [] : [
			removeOrder(windowId),
			$$BASE.closeAlert()
		]
	}
}

// 根据彩种ID获取历史开奖奖期
export function getHistoryIssues(lotteryId, windowId, issueNum = 10, loading = false){

	const payload = packageReq('GET_LOTTERY_HISTORY', [lotteryId, issueNum], null, 'GET', loading);
	return {
		type: ACTION.GET_LOTTERY_HISTORY,
		payload,
		extend: windowId,
		lotteryId: lotteryId
	}

}

// 模拟开奖
export function simulatedNumber(lotteryId, windowId){
	const payload = packageReq('SIMULATED_NUMBER', [lotteryId], null, 'GET');
	return {
		type: ACTION.SIMULATED_NUMBER,
		payload,
		extend: windowId,
		_success_:[
			{
				action: toggleSimulatStatus(windowId, false),
				takeParam: false
			}
		],
		_error_:[
			{
				action: toggleSimulatStatus(windowId, false),
				takeParam: false
			}
		],
		delayAction: 2
	}
}

// 开始模拟开奖
export function toggleSimulatStatus(windowId, status){
	return {
		type: ACTION.TOGGLE_SIMULAT_STATUS,
		status: status,
		windowId: windowId
	}
}

// 清空秒秒彩执行情况列表
export function clearMmcExcute(windowId){
	return {
		type: ACTION.MMC_CLEAR_EXCUTE,
		windowId: windowId
	}
}

// 秒秒彩中奖后停止状态
export function toggleStopWhenWin(windowId, status){
	return {
		type: ACTION.MMC_TOGGLE_STOPWHENWIN,
		windowId: windowId,
		status: status
	}
}

// 秒秒彩变更连续开奖期数
export function mmcPlayTimes(windowId, times){
	return {
		type: ACTION.MMC_CHANGE_PLAYTIMES,
		windowId: windowId,
		times: times
	}
}

// 获取彩种有效号码
export function getValidNumber(windowId, lotteryId){
	const payload = packageReq('GET_VALID_NUMBER', [lotteryId], null, 'GET', false, 60);
	return {
		type: ACTION.GET_VALID_NUMBER,
		payload,
		extend: windowId,
		lotteryId: lotteryId,
		_success_:[
			{
				action: getHistoryCodes4Miss,
				takeParam: true
			}
		]
	}
}

// 获取冷热遗漏100期
export function getHistoryCodes4Miss(result, action){
	const payload = packageReq('GET_LOTTERY_HISTORY', [action.lotteryId, 100], null, 'GET');
	return {
		type: ACTION.MAKE_MISSCODE_RULE,
		payload,
		extend: {
			windowId: action.extend,
			vaildCode: _.split(result.data.number_sets, ',')
		}
	}
}

/**
 * 获取彩种静态信息
 * @author ammo 2018-03-05
 * @param  {[type]} alias [description]
 * @return {[type]}       [description]
 */
export function getLotteryStaticInfos(alias){

	const cache = $CACHE.get('static_lottery_' + alias);
	// 有缓存时
	if (cache) {
		return {
			type: ACTION.GET_STATIC_METHOD_INFO,
			extend: alias,
			result: {data: cache.data}
		}
	}

	// 无缓存
	const payload = packageReq('GET_STATIC_METHOD_INFO', [alias], null, 'GET');
	return {
		type: ACTION.GET_STATIC_METHOD_INFO,
		payload,
		extend: alias
	}

}

// 更新订单 更新mode
export function updateModeOrder(submit, display, windowId, id){
	return {
		type: ACTION.UPDATE_MODE_LOTTERY_ODER,
		data: {
			submit: _.merge(submit),
			display: _.merge(display),
			windowId: windowId,
			id:id
		},
		relations: [
			resetTrackInfo(windowId)
		]
	}
}

// 更新订单 更新times
export function updateTimesOrder(submit, display, windowId, id){
	return {
		type: ACTION.UPDATE_TIMES_LOTTERY_ODER,
		data: {
			submit: _.merge(submit),
			display: _.merge(display),
			windowId: windowId,
			id:id
		},
		relations: [
			resetTrackInfo(windowId)
		]
	}
}

//更新订单信息
export function updateOrder(submit,display,windowId,id){
  return {
    type: ACTION.UPDATE_ORDER,
    data: {
      submit: submit,
      display: display,
      windowId: windowId,
      id:id
    },
    relations: [
      resetTrackInfo(windowId)
    ]
  }
}

/**
 * 获取不推荐彩种，此接口用于弹出提示框，当用户在非推荐彩种时弹出
 */
export function getPreventLotterys(callback){
	const payload = packageReq('GET_PREVENT_LOTTERYS', null, null, 'GET');
	return {
		type: ACTION.GET_PREVENT_LOTTERYS,
		payload,
		_callbacks_: [callback]
	}
}